<template>
  <div class="addressEdit">
    <AddressEdit
      :area-list="areaList"
      :show-postal="false"
      show-delete
      show-set-default
      show-search-result
      :search-result="searchResult"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      :address-info="address"
      @save="onSave"
      @delete="onDelete"
      @change-detail="onChangeDetail"
    />
  </div>
</template>

<script>
import { AddressEdit, Toast } from "vant";
import { initOpenid } from "@/utils/getOpenid";
import { areaList } from "@vant/area-data";
import {
  addressAdd,
  addressDelete,
  addressEdit,
} from "@/api/officialAccount/index.js";

export default {
  components: { AddressEdit },
  data() {
    return {
      areaList,
      searchResult: [],
      address: {},
      projectId: null,
    };
  },
  created() {
    if (
      process.env.NODE_ENV === "development" &&
      !localStorage.getItem("openId")
    ) {
      localStorage.setItem("openId", "dev_test_openid");
    }
    if (!localStorage.getItem("openId")) initOpenid();
    if (this.$route.query.address) {
      console.log(JSON.parse(this.$route.query.address));
      const queryaddress = JSON.parse(this.$route.query.address);
      this.projectId = queryaddress.id;
      this.address = JSON.parse(JSON.stringify(queryaddress));
      console.log(this.address);
    }
  },
  mounted() {
    console.log(location.href);
    var box = document.getElementsByClassName("van-address-edit__buttons");
    console.log(box);
    var div = document.createElement("div");
    div.innerText = "返回";
    div.style.width = "100%";
    div.style.height = "40px";
    div.style.background = "#fff";
    div.style.borderRadius = "400px";
    div.style.textAlign = "center";
    div.style.lineHeight = "40px";
    div.style.color = "#323233";
    div.style.fontSize = "14px";
    div.onclick = () => {
      this.$router.push({ name: "addressMana" });
    };
    box[0].appendChild(div);
  },
  methods: {
    async addressAddHanlde() {
      const { code } = await addressAdd({
        city: this.address.city,
        detail: this.address.addressDetail,
        name: this.address.name,
        openid: localStorage.getItem("openId"),
        phone: this.address.tel,
        province: this.address.province,
        type: this.address.isDefault ? 1 : 0,
        code: this.address.areaCode,
        area: this.address.county,
      });
      if (code !== "0000000") {
        return;
      }
      this.$router.push({
        name: "addressMana",
        params: { message: "添加成功" },
      });
      // this.push('')
    },
    async addressEditHanlde() {
      const { code } = await addressEdit({
        city: this.address.city,
        detail: this.address.addressDetail,
        name: this.address.name,
        id: this.projectId,
        phone: this.address.tel,
        province: this.address.province,
        type: this.address.isDefault ? 1 : 0,
        code: this.address.areaCode,
        area: this.address.county,
      });
      if (code !== "0000000") {
        return;
      }
      this.$router.push({
        name: "addressMana",
        params: { message: "修改成功" },
      });
      // this.push('')
    },
    async addressDelete() {
      const { code } = await addressDelete({
        id: this.projectId,
        openid: localStorage.getItem("openId"),
      });
      if (code !== "0000000") {
        return;
      }
      this.$router.push({
        name: "addressMana",
        params: { message: "删除成功" },
      });
    },
    onSave(val) {
      console.log(val);
      this.address = val;
      if (!localStorage.getItem("openId")) {
        Toast("请重新加载页面");
        return;
      }
      if (this.projectId) {
        this.addressEditHanlde();
      } else {
        this.addressAddHanlde();
      }
    },
    onDelete(val) {
      console.log(val);
      this.address = val;
      if (!localStorage.getItem("openId")) {
        Toast("请重新加载页面");
        return;
      }
      if (!this.projectId) return;
      this.addressDelete();
    },
    onChangeDetail(val) {
      console.log(val);
      // if (val) {
      //   this.searchResult = [
      //     {
      //       name: '黄龙万科中心',
      //       address: '杭州市西湖区',
      //     },
      //   ];
      // } else {
      //   this.searchResult = [];
      // }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-switch--on {
  background-color: #60bb46;
}
/deep/.van-button--danger {
  background-color: #60bb46;
  border-color: #60bb46;
}
/deep/.van-address-edit__buttons .van-button {
  margin-bottom: 20px;
}
// /deep/.van-button--default {
//   background-color: #ee0a24;
//   color: #fff;
// }
</style>
